var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-page login-2" }, [
    _c("div", { staticClass: "login-wrapper" }, [
      _c(
        "div",
        { staticClass: "login-box" },
        [_vm._m(0), _vm._v(" "), _c("router-view"), _vm._v(" "), _vm._m(1)],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-main" }, [
      _c("a", { attrs: { href: "/admin" } }, [
        _c("img", {
          attrs: { src: "/assets/img/logo-login.png", alt: "Laraspace Logo" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-copyright" }, [
      _c("p", [
        _vm._v("Powered by\n          "),
        _c("a", { attrs: { href: "http://bytefury.com", target: "_blank" } }, [
          _vm._v("Bytefury")
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Laraspace © 2016")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dd4f898", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dd4f898","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/layouts/LayoutLogin2.vue
// module id = 642
// module chunks = 0